import {CES_TEXT_REPRESENTATION} from './ces-text-representation.model';

/** Ordre d'affichage des échelles de libellés dans le paramétrage : celle par défaut d'abord. */
export const CES_TEXT_REPRESENTATIONS: CES_TEXT_REPRESENTATION[] = [
    CES_TEXT_REPRESENTATION.EASY,
    CES_TEXT_REPRESENTATION.WEAK,
    CES_TEXT_REPRESENTATION.SIMPLE,
];
